











































































import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
import Vue from "vue";
export default Vue.extend({
  components: { SkeletonLoaderItem },
  props: ["icon", "source", "items", "labels_count", "is_loading"],
});
